import { render, staticRenderFns } from "./AppRegister.vue?vue&type=template&id=329c1c1b&scoped=true&"
import script from "./AppRegister.vue?vue&type=script&lang=js&"
export * from "./AppRegister.vue?vue&type=script&lang=js&"
import style0 from "./AppRegister.vue?vue&type=style&index=0&id=329c1c1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c1c1b",
  null
  
)

export default component.exports